import { useGlobalContext } from '~/context/GlobalContext';
import styles from './EmoticonButton.module.css';

function EmoticonButton() {
  const { context, setContext } = useGlobalContext();

  const handleClick = (e: React.MouseEvent) => {
    setContext({ isActiveEmoticonContainer: !context.isActiveEmoticonContainer });
  };

  return (
    <button
      data-compoent="EmoticonButton"
      className={styles.emoticonButton}
      onClick={handleClick}
    />
  );
};

export default EmoticonButton;
